export default (ssrs = []) => ssrs.filter(ssr => ssr.id.substr(0, 2) === '5B')
